import {Component, EventEmitter, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {SwitchBoard} from "../../services/SwitchBoard";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../services/Session";

declare var jQuery: any;
declare var _: any;

@Component({
  selector: 'app-customer-header',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './customer-header.component.html',
  styleUrl: './customer-header.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CustomerHeaderComponent implements  OnInit, OnDestroy {
  isSideMenuExpanded = false;
  user: any;
  showReconnecting: boolean;
  destroy$: EventEmitter<void> = new EventEmitter<void>();

  constructor(private switchBoard: SwitchBoard) {

    this.user = Session.getUser();
    this.switchBoard.onReconnect.pipe(takeUntil(this.destroy$)).subscribe(disconnected => {
      this.showReconnecting = disconnected;
    });
    this.switchBoard.onSideBarExpand.pipe(takeUntil(this.destroy$)).subscribe(flag => {
      this.isSideMenuExpanded = flag;
    });
  }

  logout() {
    this.validateLoginAndRedirect();
  }

  ngOnInit() {
    jQuery(document).ready(function() {
      jQuery(document).foundation();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // CU-868m49jqy: refreshToken()/updateToken() were removed. Both ran only from
  // a switchBoard.onRefresh subscription, and nothing in the app ever emitted
  // onRefresh, so they were unreachable. app.component.ts owns the only token
  // refresh timer.

  validateLoginAndRedirect(){
    const data = localStorage.getItem('wall_rm');
    const details = JSON.parse(data);
    if (details && details.rememberMe){
      localStorage.clear();
    }else {
      this.switchBoard.onLogOut.next({loggedOut: true});
    }
  }

}
